import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { IWishlist } from '../../../domain/wish.interface';
import { createSharableLink } from '../../../store/wishlist/wishlist.actions';
import { makeSelectCurrentUser } from '../../../store/current-user/current-user.selectors';
import { InviteUserToRegisterComponent } from '../../organisms/organisms.index';
import { ERoutes } from '../../../assets/constants/routes';

export function WishListShareComponent(props: any) {
  const { wishlist } = props;
  const isShared = !!wishlist.locator;
  const currentUser = useSelector(makeSelectCurrentUser());

  const isAuthenticated = currentUser && !!currentUser.id;
  if (!isAuthenticated) {
    return (
      <>
        <div className='fluid-container content-wrapper'>
          <InviteUserToRegisterComponent wishlistId={wishlist.id} />
        </div>
      </>
    );
  }

  return (
    <>
      <div className='fluid-container content-wrapper'>
        <div className='list-group-item d-flex'>
          {!isShared && <ShareWishList wishlist={wishlist} />}
          {isShared && <SharePublicWishListLink wishlist={wishlist} />}
        </div>
      </div>
    </>
  );
}

function ShareWishList({ wishlist }: { wishlist: IWishlist }) {
  const dispatch = useDispatch();
  const createLink = () => {
    dispatch(createSharableLink(wishlist.id));
  };

  return (
    <>
      <div className='d-flex flex-row'>
        <div className='col-9 d-flex flex-column justify-content-center align-items-start'>
          <FormattedMessage id='atoms.share_wishlist.description' />
          <p style={{ fontSize: '16px' }}>
            <br />
            <FormattedMessage id='atoms.share_wishlist.note' />
          </p>
        </div>
        <div className='col-3 d-flex justify-content-center align-items-center'>
          <button className='btn-lili' onClick={() => createLink()}>
            <FormattedMessage id='atoms.share_wishlist.create_link' />
          </button>
        </div>
      </div>
    </>
  );
}

function SharePublicWishListLink({ wishlist }: { wishlist: IWishlist }) {
  const text: any = useRef({});
  const link = `${
    process.env.REACT_APP_BASE_URL
  }${ERoutes.WISH_LIST_PUBLIC.replace(':wishListId', wishlist.locator)}`;

  const copyToClipboard = (e: any) => {
    text.current.select();
    document.execCommand('copy');
    e.target.focus();
  };

  return (
    <>
      <div className='col-9 d-flex justify-content-start align-items-center'>
        <input
          type='text'
          ref={text}
          value={link}
          style={{ border: 0, width: '100%' }}
          readOnly={true}
        />
      </div>
      <div className='col-3 d-flex justify-content-center align-items-center'>
        <button className='btn-lili' onClick={copyToClipboard}>
          <FormattedMessage id='common.copy' />
        </button>
      </div>
    </>
  );
}
